var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"paper-example"},[_c('h1',[_vm._v("2019届湘教版九年级数学下册单元测试(二)　圆(A卷)")]),_vm._v(" "),_c('div',{staticClass:"paper-body"},_vm._l((_vm.questions),function(question,index){return _c('question-box',{key:index,attrs:{"question":question}})}),1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-226b2191","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/front/introduce/history-paper/paper-example-3/index.vue
// module id = null
// module chunks = 